import i18n from "i18next";

const changeLocale = (locale: string) => {
  // set new locale
  localStorage.setItem("locale", locale);

  // get default locale
  const defaultLocale: string = localStorage.getItem("locale") ?? i18n.language;

  // change locale
  i18n.changeLanguage(defaultLocale);
};

export default changeLocale;
